@if (canCreate) {
  <div class="toolbar">
    <button nbButton status="primary" size="small" [disabled]="creating()" (click)="create()"
            data-cy="tga-repair-task-create">
      <nb-icon icon="plus-outline" pack="eva"></nb-icon>
      Reparaturauftrag erstellen
    </button>
  </div>
}
<wr-building-repair-task-overview
  [buildingId]="buildingId()"
  [buildingEquipmentId]="buildingEquipment().id">
</wr-building-repair-task-overview>
